import React from 'react';

// Isolates every Offer AI Summary UI element: if anything inside throws, it
// renders nothing instead of taking down the Offers tab around it. Mirrors
// DocAiSummaryBoundary.
class OfferAiSummaryBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.error('[OfferAiSummary] UI error suppressed:', error);
  }

  render() {
    if (this.state.failed) return null;
    return this.props.children;
  }
}

export default OfferAiSummaryBoundary;
